import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AppComponent } from 'src/app/app.component';
import { RulesandregulationsService } from '../../Services/rulesandregulations.service';

@Component({
  selector: 'app-our-rules',
  templateUrl: './our-rules.component.html',
  styleUrls: ['./our-rules.component.scss']
})
export class OurRulesComponent implements OnInit {
  subscription = new Subscription();

  constructor(public appComponent: AppComponent, private rulesandregulationsService: RulesandregulationsService) { }

  WebPageContent: any;
  DocumentURL: any;

  ngOnInit() {
    this.getrulesandregulationsData();
  }
  ngAfterViewInit() {
    
  }

  getrulesandregulationsData() {
    this.subscription = this.rulesandregulationsService.GetRulesData().subscribe(res => {
      if (res != null)
      {
        this.WebPageContent = res.Response.Data.Content;
        this.WebPageContent = this.WebPageContent == "" ? null : this.WebPageContent; 
        this.DocumentURL = res.Response.Data.DocumentUrl;
      }
    }, err => {
      console.log('err in rulesandregulations component', err);
    });
  }

  onNavigate() {
    window.open(this.DocumentURL);
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

}
